export default "__VITE_ASSET__DrunxTaJ__"